import { registerApp, getWindow } from '../../utils.js';

const appId = 'e2eintermediateguest';
let parentHost = null;

const browserWindow = getWindow(appId);
window.emui = window.emui || { uuid: crypto.randomUUID() };

const log = (msg) => {
  const el = document.getElementById('intermediateLog');
  if (!el) return;
  const ts = new Date().toLocaleTimeString();
  el.innerHTML += `<div>[${ts}] ${msg}</div>`;
  el.scrollTop = el.scrollHeight;
};

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });

const mockLogger = {
  debug: () => {},
  info: () => {},
  warn: (...args) => console.warn('[Intermediate]', ...args),
  error: (...args) => console.error('[Intermediate]', ...args),
  audit: () => {},
};

const createUI = () => {
  document.body.innerHTML = `
    <div style="font-family:system-ui;font-size:13px;padding:8px;">
      <h3 style="margin:0 0 6px;font-size:14px;color:#0d9488;">
        Intermediate Guest B (also a host)
      </h3>
      <p style="font-size:11px;color:#6b7280;margin:0 0 6px;">
        This guest clones the parent's Loan object and re-exposes it to a grandchild.
        When the grandchild calls Loan methods, callChain propagation is exercised.
      </p>
      <div id="intermediateLog" data-testid="intermediate-log"
        style="background:#f3f4f6;padding:6px;border-radius:4px;min-height:40px;max-height:80px;font-size:11px;overflow:auto;margin-bottom:8px;"></div>
      <div id="grandchildContainer" data-testid="grandchild-container"
        style="border:2px dashed #0d9488;border-radius:6px;height:450px;"></div>
    </div>
  `;
};

window.emui.app = {
  uuid: window.emui.uuid,
  init: async (options) => {
    parentHost = options.host;
    return Promise.resolve();
  },
  mount: async () => {
    createUI();
    log('Intermediate B mounted');

    try {
      const origin = window.parent.location.origin;
      log(`Loading AppBridge UMD from ${origin}/index.js ...`);
      await loadScript(`${origin}/index.js`);
      log('AppBridge UMD loaded');
    } catch (e) {
      log(`ERROR loading UMD: ${e.message}`);
      return;
    }

    try {
      const origin = window.parent.location.origin;

      // Reset iframe <base> to root so CAppBridge resolves hostUrls correctly
      const baseTag = document.querySelector('base');
      if (baseTag) baseTag.href = `${origin}/`;

      const appBridgeB = new ice.CAppBridge({
        logger: mockLogger,
        appConfigBaseUrl: `${origin}/`,
      });
      await appBridgeB.init();
      log('CAppBridge B initialized');

      const loanProxy = await parentHost.getObject('Loan');
      if (!loanProxy) {
        log('ERROR: Loan proxy not found from parent');
        return;
      }
      log('Got Loan proxy from parent host');

      appBridgeB.addScriptingObject(loanProxy);
      log("Cloned Loan proxy into B's CAppBridge");

      const instanceId = await appBridgeB.openApp({
        id: 'e2etestguest',
        frameOptions: {
          containerId: 'grandchildContainer',
          title: 'Grandchild Guest C',
        },
        metadata: { role: 'grandchild', vendor: 'Intermediate Corp' },
      });
      log(`Opened grandchild e2etestguest (${instanceId})`);
    } catch (e) {
      log(`ERROR: ${e.message}`);
      console.error('[Intermediate]', e);
    }
  },
  unmount: async () => Promise.resolve(),
};

registerApp({ browserWindow, appId, app: window.emui.app });
